<template>
  <form
    role="form"
    class="user-group form-horizontal"
  >
    <fieldset>
      <Field
        :label="$t('ENABLED')"
        :has-tooltip="true"
        :tooltip-text="$t('ORP_FIELD_ENABLED_TT')"
      >
        <template #element>
          <ValidationProvider
            slim
          >
            <div class="col-sm-5 col-md-3">
              <nzToggle
                v-model="formData.enabled"
                @change="onChange"
              />
            </div>
          </ValidationProvider>
        </template>
      </Field>
      <div v-if="isFormEnabled">
        <Field
          :label="$t('INTRODUCTION')"
          :has-tooltip="true"
          :tooltip-text="$t('ORP_FIELD_INTRODUCTION_TT')"
        >
          <template #element>
            <ValidationProvider
              rules="required"
              slim
            >
              <div class="col-sm-8 col-md-9 col-lg-9">
                <textarea
                  v-model="formData.description"
                  type="text"
                  class="form-control"
                  required="true"
                  rows="6"
                  columns="50"
                  name="description"
                  placeholder="Please enter introduction text as plain text, HTML not supported..."
                  @input="onInput"
                  @change="onChange"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          :label="$t('ORP_FIELD_CONTACT')"
          :has-tooltip="true"
          :tooltip-text="$t('ORP_FIELD_CONTACT_TT')"
        >
          <template #element>
            <ValidationProvider
              rules="required|email"
              slim
            >
              <div class="col-sm-5 col-md-3">
                <input
                  v-model="formData.contactEmail"
                  type="text"
                  class="form-control"
                  required="true"
                  @input="onInput"
                  @change="onChange"
                >
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          :label="$t('ORP_FIELD_HAS_TERMS')"
          :has-tooltip="true"
          :tooltip-text="$t('ORP_FIELD_HAS_TERMS_TT')"
        >
          <template #element>
            <ValidationProvider
              slim
            >
              <div class="col-sm-5 col-md-3">
                <nzToggle
                  v-model="formData.requireAgreementToTerms"
                  @change="onChange"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          v-if="formData.requireAgreementToTerms"
          :label="$t('ORP_FIELD_TERMS_IS_URL')"
          :has-tooltip="true"
          :tooltip-text="$t('ORP_FIELD_TERMS_IS_URL_TT')"
        >
          <template #element>
            <ValidationProvider
              slim
            >
              <div class="col-sm-5 col-md-3">
                <nzToggle
                  v-model="formData.isTermsAndConditionsURL"
                  @change="onChange"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          v-if="formData.requireAgreementToTerms && formData.isTermsAndConditionsURL"
          :label="$t('ORP_FIELD_TERMS_URL')"
          :has-tooltip="true"
          :tooltip-text="$t('ORP_FIELD_TERMS_URL_TT')"
        >
          <template #element>
            <ValidationProvider
              rules="required"
              slim
            >
              <div class="col-sm-5 col-md-3">
                <input
                  v-model="formData.termsAndConditions"
                  v-prefix="'http://'"
                  type="text"
                  class="form-control"
                  required="true"                
                  @input="onInput"
                  @change="onChange"
                >
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          v-if="formData.requireAgreementToTerms && !formData.isTermsAndConditionsURL"
          :label="$t('ORP_FIELD_TERMS')"
          :has-tooltip="true"
          :tooltip-text="$t('ORP_FIELD_TERMS_TT')"
        >
          <template #element>
            <ValidationProvider
              rules="required"
              slim
            >
              <div class="col-sm-8 col-md-9 col-lg-9">
                <textarea
                  v-model="formData.termsAndConditions"
                  type="text"
                  class="form-control"
                  required="true"
                  rows="6"
                  columns="50"
                  placeholder="Please enter Terms And Conditions in plain text..."
                  @input="onInput"
                  @change="onChange"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          v-if="formData.url"
          :label="$t('ORP_URL')"
          :has-tooltip="true"
          :tooltip-text="$t('ORP_URL_TT')"
        >
          <template #element>
            <ValidationProvider
              slim
            >
              <TruncatedTextCopy
                :copy-text="formData.url"
              >
                <a
                  :href="formData.url"
                  target="_blank"
                  class="prp_url"
                >
                  {{ formData.url }}
                </a>
              </TruncatedTextCopy>
            </ValidationProvider>
          </template>
        </Field>
      </div>
    </fieldset>
  </form>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import nzToggle from '@/core/components/nzToggle/nzToggle';
import TruncatedTextCopy from '@/angularBridgeCode/components/TruncatedTextCopy';

export default {
  name: 'OpenRegistrationSettingsForm',
  components: {
    Field,
    nzToggle,
    TruncatedTextCopy
  },

  model: {
    prop: 'value'
  },

  props:{
    value: {
      type: Object,
      default() { 
        return {
          description: '', 
          enabled: false,
          contactEmail: '',
          requireAgreementToTerms: false,
          isTermsAndConditionsURL: false,
          termsAndConditions: '',
          url: ''
        }; 
      }
    },
  },
 
  data() {
    return {
      formData: this.value,
      tncURL: '',
      tnc: ''
    };
  },

  computed: {
    isFormEnabled() {
      return this.formData.enabled;
    },

    terms() {
      if (this.formData.isTermsAndConditionsURL) {
        return this.tncURL;
      }

      return this.tnc;
    }
  },

  methods: { 
    onInput() {
      this.$emit('input', this.formData);
    },
    onChange() {
      this.$emit('change', this.formData);
    },

    setTnC() {
      if (this.formData.isTermsAndConditionsURL) {
        this.formData.termsAndConditions = this.tncURL;
      } else {
        this.formData.termsAndConditions = this.tnc;
      }
    }
  },

  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style>

</style>